import React from 'react'
import { Row, Col, Typography } from 'antd'
import { IconInfo } from '@edulastic/icons'

const AIMultiSelectItemTypeInfo = () => {
  return (
    <Row gutter={30}>
      <Col
        xs={24}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          marginTop: '6px',
        }}
        role="note"
        aria-label="AI question distribution information"
      >
        <IconInfo fill="#8A6700" aria-hidden="true" />
        <Typography.Text
          type="secondary"
          style={{
            fontSize: '12px',
          }}
          id="ai-distribution-info"
        >
          AI will try to distribute questions evenly among your selected
          question types.
        </Typography.Text>
      </Col>
    </Row>
  )
}

export default AIMultiSelectItemTypeInfo
